/** @file Export dialog, sprite sheets only: frame size, fps, layout and directions. */
import { CheckList } from '../../ui-kit/CheckList';
import type { FieldsProps } from './ExportFields';
import { formSetter } from './formSetter';

/** `directions` lists the document's direction set (empty without one, and then the list is hidden). */
export function SpriteFields({ t, form, onChange, directions }: FieldsProps & { directions: readonly string[] }) {
  const set = formSetter(form, onChange);
  return (
    <div className="export-fields">
      <label>{t('exportDialog.frameW')}<input type="number" min={16} max={4096} value={form.frameW} onChange={(e) => { set('frameW', Number(e.target.value)); }} /></label>
      <label>{t('exportDialog.frameH')}<input type="number" min={16} max={4096} value={form.frameH} onChange={(e) => { set('frameH', Number(e.target.value)); }} /></label>
      <label>{t('exportDialog.fps')}<input type="number" min={0} max={120} value={form.fps} onChange={(e) => { set('fps', Number(e.target.value)); }} /></label>
      <label>{t('exportDialog.layout')}
        <select value={form.layout} onChange={(e) => { set('layout', e.target.value === 'packed' ? 'packed' : 'grid'); }}>
          <option value={'grid'}>{t('exportDialog.layoutGrid')}</option>
          <option value={'packed'}>{t('exportDialog.layoutPacked')}</option>
        </select>
      </label>
      <CheckList legend={t('exportDialog.directions')} options={directions} picked={form.directions} onChange={(next) => { set('directions', next); }} />
    </div>
  );
}
